import i18n from 'i18n'
import * as React from "react"
import { SelectSeeker } from "ui-seeker/core"

import { SelectLoading } from "app/components/loading"
import { useCommonFilters } from "../../hooks"


export default function SelectOtherSites({...props}) {
    
    const myProps = {
        placeholder: i18n.t('common:filters.otherSites'),
        icon: { icon: 'map-marker' },
        ...props
    }

    const { elementsOtherSites } = useCommonFilters()

    if (!props.date) return <SelectLoading style={{ borderRadius: '0 6px 6px 0', borderLeft: 'none' }} />
    if (!elementsOtherSites) return <></>

    return <SelectSeeker options={elementsOtherSites} {...myProps} />
}